<template>
<div>
  <footer class="footer">
    <div class = "columns is-mobile is-vcentered">
      <div class = "column has-text-left">
        <span class = "has-text-white"> © José Ortiz Domínguez, {{ " " + getCurrentYear }} </span>
      </div>
      <div class = "column has-text-right">
        <div class="has-text-right">
          <p>
            <a class = "has-text-white" @click="toLegal()"> Aviso legal </a>
          </p>
          <p>
            <a class = "has-text-white" @click="toPrivacy()"> Política de privacidad </a>
          </p>
          <p>
            <a class = "has-text-white" @click="checkLogIn()"> Área privada </a>
          </p>
        </div>
      </div>
    </div>
  </footer>

  <div class="modal" :class = "{'is-active': loginForm}">
    <div class="modal-background"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">Inicia sesión</p>
        <button class="delete" @click = "loginForm = false"> </button>
      </header>
      <section class="modal-card-body">
        <div class="notification is-danger" v-show = "loginError"> 
          <button class="delete" @click="loginError = false"></button>
          Tu usuario o contraseña no son correctos.
        </div>
        <div class = "field is-horizontal">
          <label for = "usernameL" class = "field-label has-text-weight-bold"> Usuario </label>
          <div class = "control field-body">
            <input id ="usernameL" class = "input" type = "text" placeholder="Usuario" v-model="username"/>
          </div>
        </div>
        <div class = "field is-horizontal">
          <label for= "passwordL" class = "field-label has-text-weight-bold"> Contraseña </label>
          <div class = "control field-body">
            <input id = "passwordL" class = "input" type = "password" placeholder= "Contraseña" v-on:keyup.enter="logIn" v-model="password"/>
          </div>
        </div>
      </section>
      <footer class="modal-card-foot has-text-centered">
        <button class="button is-primary" style = "margin:auto" @click="logIn()">Iniciar sesión</button>
        <a @click = "forgotPasswordMenu()"> ¿Has olvidado tu contraseña? </a>
      </footer>
    </div>
  </div>

  <div class="modal" :class = "{'is-active': forgotPassword}">
    <div class="modal-background"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">Recupera tu contraseña</p>
        <button class="delete" @click = "forgotPassword = false"> </button>
      </header>
      <section class="modal-card-body">
        <div class="field is-horizontal">
          <div class="field-label is-normal">
            <label class="label">Email</label>
          </div>
          <div class="field-body">
            <div class="field">
              <div class="control">
                <input class="input" :class = "{'is-danger': emailWrong}" type="email" placeholder="Introduce tu email" v-model = "email">
              </div>
              <p class="help is-danger" v-show = "emailWrong">
                Este campo es requerido
              </p>
            </div>
          </div>
        </div>
      </section>
      <footer class="modal-card-foot has-text-centered">
        <button class="button is-primary" style = "margin:auto" @click="forgotPasswordSend()">Recuperar mi contraseña</button>
      </footer>
    </div>
  </div>

  <div class="modal" :class = "{'is-active': success}">
    <div class="modal-background"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">Correo electrónico enviado</p>
        <button class="delete" @click = "success = false"> </button>
      </header>
      <section class="modal-card-body">
        Te hemos enviado un correo con un enlace para recuperar tu contraseña
      </section>
      <footer class="modal-card-foot has-text-centered">
        <button class="button is-primary" style = "margin:auto" @click="success = false">OK</button>
      </footer>
    </div>
  </div>

</div>
</template>

<script>

import _ from 'lodash';
import {requester} from '../App.vue'; 
import {store} from '../store.js';

export default {
  name: 'Footer',
  data(){
    return{
      loginForm: false,
      username: "",
      password: "",
      loginError: false,
      forgotPassword: false,
      email: "",
      emailWrong: false,
      success: false
    }
  },
  computed: {
    getCurrentYear: function(){
      return new Date().getFullYear().toString();
    }
  },
  methods: {
    logIn: _.debounce(function(){
      requester.post('login', {
        username: this.username,
        password: this.password
      }).then(response => {
        let token = response.data.token;
        let expiryDate = response.data.expiryDate;
        store.commit('setToken', token);
        store.commit('setExpiryDate', expiryDate);
        this.loginForm = false;
        this.$router.push('/editGallery')
      }).catch(() => {
        this.loginError = true;
      })
    }, 2000, {leading: true}),
    checkLogIn: _.debounce(function(){
      let expiryDate = store.state.expiryDate;
      if (Date.now() > Date.parse(expiryDate)){
        this.loginForm = true;
      } else {
        this.$router.push('/editGallery')
        //this.loginForm = true;
      }
    }),
    toLegal: function(){
      this.$router.push('/legal');
    },
    toCookies: function(){
      this.$router.push('/cookies');
    },
    toPrivacy: function(){
      this.$router.push('/privacy');
    },
    forgotPasswordMenu: function(){
      this.loginForm = false;
      this.forgotPassword = true;
    },
    forgotPasswordSend: function(){
      var emailPattern = /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i;
      if(!emailPattern.test(this.email)){
        this.emailWrong = true;
      } else {
        this.emailWrong = false;
      }

      if(this.emailWrong){
        return;
      }

      requester.post('resetPassword', {
        email: this.email
      },
      ).then(() => {
        this.success = true;
        this.forgotPassword = false;

      }).catch(() => {
        
      })

    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.title-font {
  font-family: "Baloo Bhaina 2";
}

h1, h2 {
  font-weight: normal;
}
div {
  text-align: center;
  font-family: 'Century Gothic', 'Tahoma', 'Verdana'
}
.footer {
  background-color: #222222;
  padding: 24px;
}

</style>
